/**
 * Feature Capabilities Configuration
 *
 * Controls which features are enabled/visible in the UI.
 * Only enable features that have working backend endpoints.
 *
 * LOCKED CANON: Do not enable features unless backend endpoints are confirmed working.
 */

export const CAPABILITIES = {
    // ─── Client Features ───
    client: {
        games: true,
        wallet: true,
        walletDeposit: {
            manual: true,
            gateway: true, // Gateway deposit enabled
        },
        walletWithdraw: true,
        transactions: true,
        publicCheckout: true,
        achievements: true,
        referrals: true,
        inbox: true,
        profile: true,
        chat: true, // Phase 4: live — player /messages surface
    },

    // ─── Admin Features ───
    admin: {
        core: true,
        users: true,
        paymentMethods: true,
        auditLogs: true,
        integrations: true,
        games: true,
        promotions: true,
        achievements: true,
        referralTiers: true,
        leaderboards: true, // Slice 1A: read APIs + admin config endpoints live
        winnersFeed: true, // Slice 2: winners feed module
        walletRules: true,
        deposits: true,
        withdrawals: true,
        notifications: true,
        security: true,
        staffManagement: true,
        webhooks: true,
        reviewerTargets: true,
        ordersTimeline: true, // Phase 11+: Engine-based orders/payments/payouts
    },

    // ─── Auth Methods ───
    auth: {
        magicLink: true,
        socialAuth: false, // Not implemented
        forgotPassword: true,
    },

    // ─── Info Pages ───
    rulesPages: true,
};

/**
 * Check a capability by dot-notation path
 * e.g. hasCapability('client.wallet') or hasCapability('admin.users')
 */
export const hasCapability = (path) => {
    const parts = path.split(".");
    let current = CAPABILITIES;
    for (const part of parts) {
        if (current === undefined || current === null) return false;
        if (typeof current === "boolean") return current;
        current = current[part];
    }
    if (typeof current === "boolean") return current;
    if (typeof current === "object" && current !== null) return true; // Object = enabled namespace
    return false;
};

/**
 * Require capability or throw
 */
export const requireCapability = (path) => {
    if (!hasCapability(path)) {
        throw new Error(`Feature '${path}' is not available`);
    }
};

export default CAPABILITIES;
